var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 8.4L20.6001 7.25C16.5501 3.3 6.8501 3.85 3.3501 7.25L2.2001 8.4C1.9001 8.7 1.9001 9.2 2.2001 9.55L4.5001 11.8C4.8001 12.1 5.3501 12.1 5.6501 11.8L8.2001 9.35L8.0001 6.7C8.8001 5.9 15.2001 5.9 16.0001 6.7L15.8501 9.45L18.3001 11.8C18.6001 12.1 19.1501 12.1 19.4501 11.8L21.7501 9.55C22.1001 9.2 22.1001 8.7 21.7501 8.4Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.25L8 15.5H16L12 20.25Z",
    fill: "#B71C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12H13.5V15.75H10.5V12Z",
    fill: "#B71C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end-call.1d465b80c3606926524295e368fb6595.svg";
export { ForwardRef as ReactComponent };